// extracted by mini-css-extract-plugin
module.exports = {"container":"RecurrenceCalendar_container__3fwhn"};